import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Grid, Col, Button, Row, ButtonToolbar } from 'react-bootstrap';
import { EMPTY_STRING, ERROR, EMPTY_COUNT } from '../../../utils/constants';
import FormTemplate from '../../components/FormTemplate';
import { productClassOperations } from "../ProductClass/state";
import { proposalOperations } from "./state";
import TableTemplate from '../../components/TableTemplate';
import { EDIT_PROPOSAL, PROPOSALS } from './routes';
import ErrorAlert from '../../components/ErrorAlert';
import { ERROR_PRODUCT_CREATE } from '../../../utils/messages';

class AddProduct extends Component {
    constructor(props) {
        super(props);
        this.state = {
            proposalId: EMPTY_STRING,
            productClassCode: EMPTY_STRING,
            productName1: EMPTY_STRING,
            productName2: EMPTY_STRING,
            productKana: EMPTY_STRING,
            productList: [],
            error: []
        };
    }


    componentWillMount() {
        this.props.fetchProductClass();

        let id = this.props.match.params.id;

        if (undefined !== id) {
            if(undefined === this.props.location.state){
                this.props.history.push(PROPOSALS);
            }

            this.setState({ proposalId: id });
        }
    }

    filterList = (filter) => {
        this.props.filterProductList(filter).then((result) => {
            if (ERROR === result.status) {
                this.setState({ error: [result.message] });
            } else {
                this.setState({ productList: result.data, error: [] });
            }
        })
    }

    setFilter = () =>{
        let filter = {
            proposalId: this.state.proposalId,
            productClassCode: this.state.productClassCode,
            productName1: this.state.productName1,
            productName2: this.state.productName2,
            productKana: this.state.productKana
        }

        this.filterList(filter);
    }

    insertProduct = (row) => {
        let details = {
            strProductCode: row.strProductCode,
            proposalId: this.state.proposalId,
            productPrice: null,
            orderControlCode: null
        }


        this.props.insertProduct(details, this.props.user.user_cd).then((result)=>{
            if (ERROR === result.status) {
                this.setState({ error: [result.message] });
            } else {
                this.showProposal();
            }
        }).catch(()=>this.setState({ error: [ERROR_PRODUCT_CREATE] }))
    }

    showProposal = () => {
        this.props.history.push(EDIT_PROPOSAL + "/" + this.state.proposalId);
    }

    handleInputChange = (event) => {
        this.setState({ [event.target.name]: event.target.value });
    }

    render() {
        return (
            <Grid fluid={true}>
                <Grid>
                    <ErrorAlert errors={this.state.error}/>
                    
                    <Row className="custom-flex-end">
                        <Col xs={5}>
                            <FormTemplate
                                xs={true}
                                {...this.props}
                                {...this.state}
                                selectInput={[{name: "productClassCode", label: EMPTY_STRING, value: EMPTY_COUNT}].concat(this.props.selectClass)}
                                className="product-form"
                                horizontal={true}
                                handleInputChange={this.handleInputChange}
                            />
                        </Col>
                        <ButtonToolbar className="add-toolbar-style">
                            <Button
                                className="button-common mb-1"
                                onClick={() => this.setFilter()}>
                                {"検索"}
                            </Button>
                            <Button
                                className="button-common mb-1"
                                onClick={() => this.showProposal()}>
                                {"戻る"}
                            </Button>
                        </ButtonToolbar>
                    </Row>
                    
                    <TableTemplate
                        {...this.props}
                        tableName={"productTable"}
                        tableList={this.state.productList}
                        rowButtons={[
                            {
                                onClick: this.insertProduct,
                                icon: "plus-circle",
                                bsStyle: "link"
                            }
                        ]}
                    />

                </Grid>
            </Grid>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        user: state.auth.credentials,
        formInputs: state.proposal.addProductForm,
        selectClass: state.productClass.select,
        tableHeader: state.proposal.addProductTableHeader,
        tableColumns: state.proposal.addProductTableColumns
    }
};

const mapDispatchToProps = {
    fetchProductClass: productClassOperations.fetchDefault,
    filterProductList: proposalOperations.filterProductList,
    insertProduct: proposalOperations.insertProduct
};

export default connect(mapStateToProps, mapDispatchToProps)(AddProduct);